import $ from 'jquery';
require('fancybox')($);
//import {fancybox} from './fancybox';
export function setFancyBox(){
	$('.post .post-body img').each(function() {
		if ( $(this).parent().is('a') ){
			$(this).parent().addClass('fancybox').attr('rel', 'gal');
		}
	});

	$.fancybox.open($('.fancybox'));

	$(".ver-video").on('click',function() {
		$.fancybox({
			'padding'		: 0,
			'autoScale'		: false,
			'transitionIn'	: 'none',
			'transitionOut'	: 'none',
			'title'			: this.title,
			'width'			: '95%',
			'height'		: '90%',
			'href'			: this.href.replace(new RegExp("watch\\?v=", "i"), 'v/'),
			'type'			: 'swf',
			'swf'			: {
				'wmode'				: 'transparent',
				'allowfullscreen'	: 'true'
			},
			'showCloseButton':	true
		});
		return false;
	});
}

export function slideNav(element){
	var contentSections = $('.home .section-container');
	var	navigationItems = $('#vertical-nav a');
	$('body').css('margin-bottom', '352');
	updateNavigation();
	onScroll();
	$(window).on('scroll', function() {
		updateNavigation();
	});
	//smooth scroll to the section
	navigationItems.on('click', function(event) {
		event.preventDefault();
		smoothScroll($(this).attr('href'));
	});

	function updateNavigation() {
		contentSections.each(function() {
			var activeSection = $('#vertical-nav a[href="#' + $(this).attr('id') + '"]').data('number') - 1;
			if ( ( $(this).offset().top - $(window).height()/2 < $(window).scrollTop() ) && ( $(this).offset().top + $(this).height() - $(window).height()/2 > $(window).scrollTop() ) ) {
				navigationItems.eq(activeSection).addClass('is-selected');
			} else {
				navigationItems.eq(activeSection).removeClass('is-selected');
			}
		});
	}

	function smoothScroll(target) {
		$('html, body').animate({scrollTop : $(target).offset().top}, 600);
	}

	function onScroll() {

		var delay = false;

		$(element).on('mousewheel DOMMouseScroll', function(event) {
			if( $(window).scrollTop() >= $('#home-extras').offset().top-100 ){

			} else {

				event.preventDefault();
				if(delay) return;
	
				delay = true;
				setTimeout(function(){delay = false},200)
	
				var wd = event.originalEvent.wheelDelta || -event.originalEvent.detail;
	
				if(wd < 0) {
					for(var i = 0 ; i < contentSections.length ; i++) {
						var t = contentSections[i].getClientRects()[0].top;
						if(t >= 40) break;
					}
				} else {
					for(var i = contentSections.length-1 ; i >= 0 ; i--) {
						var t = contentSections[i].getClientRects()[0].top;
						if(t < -20) break;
					}
				}
				if(i >= 0 && i < contentSections.length) {
					$('html,body').animate({ scrollTop: contentSections[i].offsetTop });
				}
			}
		});
	};
}


// WEBPACK FOOTER //
// ./src/flux/functions.js